// src/utils/auth.js

const TOKEN_KEY = 'user-token'
const USER_INFO_KEY = 'user-info'


// Token相关操作
export function getToken() {
    return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token) {
    return localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken() {
    return localStorage.removeItem(TOKEN_KEY)
}

// 用户信息相关操作
export function getUserInfo() {
    const userInfo = localStorage.getItem(USER_INFO_KEY)
    return userInfo ? JSON.parse(userInfo) : null
}

export function setUserInfo(info) {
    localStorage.setItem(USER_INFO_KEY, JSON.stringify(info))
}

export function removeUserInfo() {
    return localStorage.removeItem(USER_INFO_KEY)
}

// 登录状态判断
export function isLoggedIn() {
    return !!getToken()
}

// 清除所有认证信息
export function clearAuth() {
    removeToken()
    removeUserInfo()
}